import { render, staticRenderFns } from "./mails.layout.vue?vue&type=template&id=70570424&scoped=true&"
import script from "./mails.layout.vue?vue&type=script&lang=js&"
export * from "./mails.layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70570424",
  null
  
)

export default component.exports